// extracted by mini-css-extract-plugin
export default {"widgetFallback":"WidgetErrorFallback_widgetFallback__uVSUM","errorTitle":"WidgetErrorFallback_errorTitle__2hbSy","errorSubTitle":"WidgetErrorFallback_errorSubTitle__9rwvE"};